<button mat-icon-button
  (click)="openSidenav()">
  <mat-icon>filter_list</mat-icon>
</button>